<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head">
            <h1>
              {{ $t(`modal.bottom+radio.${constantType.toLowerCase()}`) }}
            </h1>
          </div>

          <div class="modal-delete">
            <i class="i-modal-delete" @click="emit('close')"></i>
          </div>

          <div class="modal-con check">
            <div class="modal-txt">
              <ul class="check-ul">
                <li class="form-li" v-for="(selection, index) in selectionList" :key="`${selection.constant}`">
                  <div class="radio-box">
                    <label class="radio" @input="fnSelect(selection)">
                      <input type="radio" name="radio" v-model="selectedValue" :value="selection.key" />
                      <span class="radio-txt">
                        {{ translator(selection) }}
                      </span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-btn">
            <div class="btn-wrap">
              <!--                                <button class="btn bo">취소</button>-->
              <button class="btn yd-cta yd-cta--secondary" @click="confirm">
                {{ $t('modal.delivery_fee_sort.close_btn') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import store from '@/store';
import Util from '@/common/utils/Util';

const { translator } = Util;
const { params } = useRoute();
const { getters, dispatch, commit } = useStore();
const emit = defineEmits();
const { data } = defineProps({
  data: {
    type: Object
  }
});

const { constantType } = data;

onMounted(() => {
  const currentFilter = computed(() => getters['search/getFilter']);
  if (currentFilter.value[`${constantType}`]) {
    selectedValue.value = currentFilter.value[`${constantType}`];
  } else {
    selectedValue.value = setDefaultValue(constantType);
  }
});

const selectedValue = ref('');
const selectionList = computed(() => getters['constant/getConstant'][constantType]);
const locale = computed(() => store.getters['locale/getLocale']);
const setDefaultValue = (constantType) => {
  switch (constantType) {
    case 'STORE_ORDER_BY_CONDITION':
      return 'STORE_ORDER_REG_DATE';
    case 'STORE_DELIVERY_FEE_CONDITION':
      return 'DELIVERY_ALL';
    case 'STORE_REQUIRED_PAY_AMOUNT_CONDITION':
      return 'STORE_REQUIRED_ALL';
    case 'STORE_STAR_CONDITION':
      return 'STORE_STAR_ALL';
    case 'STORE_ETC_CONDITION':
      return 'ETC_ALL';
  }
};

const fnSelect = async (selection) => {
  const selectedCondition = {
    key: constantType,
    value: selection.key
  };
  // 선택한 필터 세팅
  commit('search/setSelectFilter', selectedCondition);

  // 기존 리스트 정보 초기화
  commit('store/initStoreList');
  commit('store/initRecommendedStoreList');

  // await dispatch('store/fetchStoreList', {
  //   storeCategoryNo: params.storeCategoryNo
  // });
  await dispatch('store/fetchRecommendedStoreList', {
    storeCategoryNo: params.storeCategoryNo
  });
  commit('store/updateInfiniteKey');

  // if (!!params.storeCategoryNo) {
  //   replace(`/search/result`);
  // } else {
  //   replace(`/search/result/${params.storeCategoryNo}`);
  // }

  emit('close');
};
const confirm = () => {
  emit('close');
};
</script>

<style scoped></style>
/* *Created on 2023-09-04 *ProjectName user */
